<template>
  <section id="produkttrailer" class="produkttrailer">
    <div class="container">
      <div class="videoContainer">
        <VideoComponent name="ies3_smoke_evacuation_system">
          <VideoIcon />
          <p class="videoButtonTitleFonts">
            <span class="boldTitle">{{
              $t("IES3_production_trailer_title_bold_beginning")
            }}</span>
            {{ $t("IES3_production_trailer_title_nonbold_ending") }}
          </p>
        </VideoComponent>
      </div>
    </div>
  </section>
</template>

<script>
import VideoComponent from "@/components/VideoComponent";
import VideoIcon from "@/components/VideoIcon";
import { languageAdapter } from "@/services/languageAdapter";
export default {
  name: "ProductTrailer",
  components: {
    VideoComponent,
    VideoIcon
  },
  computed: {
    videoToShow() {
      const { videos, language } = this.$store.state;
      return videos[language]["ies3_smoke_evacuation_system"];
    }
  }
};
</script>
<style scoped>
.videoContainer {
  display: flex;
  padding: 1rem;
}
.produkttrailer {
  margin-top: auto;
}
.boldTitle {
  font-family: "Netto Bold", "Open Sans", sans-serif;
  color: black;
}
.videoButtonTitleFonts {
  margin-top: auto;
    margin-bottom: auto;
    margin-left: 1rem;
    min-width: 210px;
    max-width: 60vw;
}
</style>
